import { render } from "./matrix.vue?vue&type=template&id=3a498430&scoped=true"
import script from "./matrix.vue?vue&type=script&lang=js"
export * from "./matrix.vue?vue&type=script&lang=js"

import "./matrix.vue?vue&type=style&index=0&id=3a498430&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a498430"]])

export default __exports__